// extracted by mini-css-extract-plugin
export default {"wrapper":"priests_wrapper__DpOpB","priest":"priests_priest__7RPxe","name":"priests_name__V5+tx","info":"priests_info__VKnFA"};